import React from 'react';
import classNames from 'classnames';

import styles from './trendingResearchListStyles';

import Link from 'buyside/components/presentation/Link/link';
import EmployerAssociation from 'buyside/components/presentation/EmployerAssociation/employerAssociation';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import AnonEmployerAssociation from 'buyside/components/presentation/EmployerAssociation/anonEmployerAssociation';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';

import { get } from 'buyside/util/lodashAltJs';
import { ideaUrl, userUrl, defaultUserImageUrl } from 'buyside/util/urlHelper';

const TrendingResearchListItem = ({ trendingItem, number, percentageChange, showUserDetails }) => {
  const mostRecentEmployer = trendingItem.user.mostRecentEmployer;
  const isCurrentEmployer = mostRecentEmployer && mostRecentEmployer.currentEmployer;
  const isRedacted = trendingItem.positions[0].entityName === 'Redacted';

  return (
    <div className={styles.trendingResearchListItem}>
      <div className={styles.trendingListNumber}>{number}.</div>
      <div className={styles.trendingListContent}>
        <div>
          {isRedacted ? (
            <RedactedDataPoint Wrapper="div" />
          ) : (
            <Link to={ideaUrl(trendingItem.id)} className={styles.ideaLink}>
              {trendingItem.positions.map(position => (
                <div key={position.id}>
                  {position.entityName} ({position.primarySymbol})
                </div>
              ))}
            </Link>
          )}
        </div>
        <div className={styles.userProfile}>
          <span className={styles.spacing}>
            <ProfileImage
              size="tiny"
              source={showUserDetails ? trendingItem.user.profileImageUrl : defaultUserImageUrl()}
            />
          </span>
          <span>
            {showUserDetails ? (
              <>
                <Link to={userUrl(trendingItem.user.id)}>{trendingItem.user.displayName}</Link>
                <EmployerAssociation
                  mostRecentEmployer={mostRecentEmployer}
                  style={styles.employerAssociation}
                />
              </>
            ) : (
              <>
                <AnonymousUserDisplay
                  anonUser={{ title: get(mostRecentEmployer, ['title'], '') }}
                />
                <AnonEmployerAssociation
                  aumRange={isCurrentEmployer ? mostRecentEmployer.employer.aumRange : null}
                  fundType={isCurrentEmployer ? mostRecentEmployer.employer.fundType : null}
                  profileCity={trendingItem.user.profileCity}
                  employerStyles={styles.anonEmployer}
                  cityStyles={styles.anonEmployer}
                />
              </>
            )}
            {percentageChange && (
              <div
                className={classNames(styles.percentage, {
                  [styles.negative]: percentageChange < 0
                })}
              >
                {percentageChange > 0 && '+'} {percentageChange}% in 30 days
              </div>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TrendingResearchListItem;
